/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Offline_Banner_ChangesInputs */

const en_us2_offline_banner_changes = /** @type {(inputs: Offline_Banner_ChangesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 change did not sync`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 change did not sync`);
	return /** @type {LocalizedString} */ (`${i?.count} changes did not sync`)
	
};

const pt_br2_offline_banner_changes = /** @type {(inputs: Offline_Banner_ChangesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 alteração não sincronizou`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 alteração não sincronizou`);
	return /** @type {LocalizedString} */ (`${i?.count} alterações não sincronizaram`)
	
};

const es_419_offline_banner_changes = /** @type {(inputs: Offline_Banner_ChangesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 cambio no se sincronizó`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 cambio no se sincronizó`);
	return /** @type {LocalizedString} */ (`${i?.count} cambios no se sincronizaron`)
	
};

const pt_pt2_offline_banner_changes = /** @type {(inputs: Offline_Banner_ChangesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 alteração não sincronizou`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 alteração não sincronizou`);
	return /** @type {LocalizedString} */ (`${i?.count} alterações não sincronizaram`)
	
};

const fr_fr2_offline_banner_changes = /** @type {(inputs: Offline_Banner_ChangesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 modification non synchronisée`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 modification non synchronisée`);
	return /** @type {LocalizedString} */ (`${i?.count} modifications non synchronisées`)
	
};

const de_de2_offline_banner_changes = /** @type {(inputs: Offline_Banner_ChangesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Änderung nicht synchronisiert`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 Änderung nicht synchronisiert`);
	return /** @type {LocalizedString} */ (`${i?.count} Änderungen nicht synchronisiert`)
	
};

const it_it2_offline_banner_changes = /** @type {(inputs: Offline_Banner_ChangesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 modifica non sincronizzata`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 modifica non sincronizzata`);
	return /** @type {LocalizedString} */ (`${i?.count} modifiche non sincronizzate`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 change did not sync" |
* | "-1" | "1 change did not sync" |
* | * | "{count} changes did not sync" |
*
* @param {Offline_Banner_ChangesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_banner_changes = /** @type {((inputs: Offline_Banner_ChangesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Banner_ChangesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_banner_changes(inputs)
	if (locale === "es-419") return es_419_offline_banner_changes(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_banner_changes(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_banner_changes(inputs)
	if (locale === "de-DE") return de_de2_offline_banner_changes(inputs)
	if (locale === "it-IT") return it_it2_offline_banner_changes(inputs)
	return en_us2_offline_banner_changes(inputs)
});
export { offline_banner_changes as "offline.banner_changes" }